import { isTouch } from './utils';

const html = document.querySelector('html');
const infoBoxEl = document.querySelector('.partial__info-box');
const infoBoxButtonEl = document.querySelector('.info-button');
const infoOverlay = document.querySelector('.info-overlay');
const infoClose = infoBoxEl.querySelector('.close');

function init (){
  if (isTouch) {
    html.classList.add('has-touch');
  }

  bindInfoBoxEvents();
}

function bindInfoBoxEvents() {
  // infoBoxEl && infoBoxEl.addEventListener('click', toggleInfoBox);
  infoBoxButtonEl && infoBoxButtonEl.addEventListener('click', toggleInfoBox);
  infoOverlay && infoOverlay.addEventListener('click', toggleInfoBox);
  infoClose && infoClose.addEventListener('click', toggleInfoBox);
}

function toggleInfoBox(evt) {
  evt.stopPropagation();
  evt.preventDefault();

  const isActive = infoBoxEl.classList.contains('is-active');

  if (isActive) {
      infoBoxEl.classList.remove('is-active');
      infoOverlay.classList.remove('is-active');
      document.body.classList.remove('info-box-is-active');
  } else {
      infoBoxEl.classList.add('is-active');
      infoOverlay.classList.add('is-active');
      document.body.classList.add('info-box-is-active');
  }
}

// we attach the toggleInfoBox function to the global window object
// in order to be able to call it from a react component
window.toggleInfoBox = toggleInfoBox;

export default {
  init
};
